import React from 'react';
import tw from 'twin.macro';

export const Container = ({ children, noSpacing = false, noMaxWidth = false, ...restProps }) => {
  return (
    <div
      css={[
        !noMaxWidth &&
          tw`transition-max-width duration-500 mx-auto
    xl:max-w-screen-xl 2xl:max-w-screen-2xl
    min-w-[340px]`,
        noMaxWidth && tw`w-full`,
        !noSpacing && tw`px-2 sm:px-4`,
      ]}
      {...restProps}
    >
      {children}
    </div>
  );
};
